import { createContext, useContext } from 'react';

const BottomNotificationContext = createContext(null);

const BottomNotificationProvider = BottomNotificationContext.Provider;
const useBottomNotificationContext = () => useContext(BottomNotificationContext);

export { BottomNotificationProvider, useBottomNotificationContext };
